import { navigate } from 'gatsby';
import { useIntl } from 'gatsby-plugin-react-intl';

export interface Route {
  label: string;
  title: string;
  url: string;
  language?: string[];
  children?: Route[];
  inMainMenu: boolean;
}

export function useRoutes() {
  const intl = useIntl();

  return [
    // {
    //   label: intl.formatMessage({
    //     id: 'navLabelHomePage',
    //     defaultMessage: 'Strona Domowa',
    //   }),
    //   title: intl.formatMessage({
    //     id: 'navTitleHomePage',
    //     defaultMessage: 'Consultchem Design',
    //   }),
    //   url: '/',
    //   inMainMenu: true,
    // },
    {
      label: intl.formatMessage({
        id: 'navLabelContact',
        defaultMessage: 'Kontakt',
      }),
      title: intl.formatMessage({
        id: 'navTitleContact',
        defaultMessage: 'CD Kontakt',
      }),
      url: '/kontakt',
      inMainMenu: true,
    },
    {
      label: intl.formatMessage({
        id: 'navLabelCompanyData',
        defaultMessage: 'Dane Firmy',
      }),
      title: intl.formatMessage({
        id: 'navTitleCompanyData',
        defaultMessage: 'CD Dane Firmy',
      }),
      url: '/dane-firmy',
      inMainMenu: true,
    },
    {
      label: intl.formatMessage({
        id: 'navLabelCalc',
        defaultMessage: ' Kalkulatory Techniczne',
      }),
      title: intl.formatMessage({
        id: 'navTitleCalc',
        defaultMessage: 'CD Kalkulatory Techniczne',
      }),
      url: '/kalkulatory',
      inMainMenu: true,
      language: ['pl'],
      childern: [
        {
          label: intl.formatMessage({
            id: 'navLabelCalcPressureVessels',
            defaultMessage: 'kalkulatory Technicze: Zbiorniki Ciśnieniowe',
          }),
          title: intl.formatMessage({
            id: 'navTitleCalcPressureVessels',
            defaultMessage: 'CD Zbiorniki Ciśnieniowe',
          }),
          url: '/zbiorniki',
          inMainMenu: false,
        },
        {
          label: 'kalkulatory Technicze: Rurociągi Ciśnieniowe',
          title: 'CD Rurociągi',
          url: '/rurociagi',
          inMainMenu: false,
        },
        {
          label: 'kalkulatory Technicze: Osprzęt Ciśnieniowy',
          title: 'CD  Osprzęt Ciśnieniowy',
          url: '/osprzet_cisnieniowy',
          inMainMenu: false,
        },
        {
          label: 'kalkulatory Technicze: Urządzenie Zabezpieczające',
          title: 'CD  Urządzenie Zabezpieczające',
          url: '/urzadzenie_zabezpieczajace',
          inMainMenu: false,
        },
      ],
    },
  ].filter(config =>
    config.language
      ? config.language.some(allowedLocale => intl.locale === allowedLocale)
      : true
  );
}

export const navigateToCalculatorList = () => navigate(`/kalkulatory`);

export const navigateToCalculator = (calcName: string) => () =>
  navigate(`/kalkulatory/${calcName}`);
